<template>
  <div ref="container" style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: auto;"
       :style="{ width: width, height: width }"
  >
  </div>
</template>
<script>
import * as echarts from 'echarts/core'
import { GaugeChart } from 'echarts/charts'
import { SVGRenderer } from 'echarts/renderers'
import resizeMixin from './resizeMixin'

echarts.use([GaugeChart, SVGRenderer])
export default {
  name: 'GaugeChart',
  mixins: [resizeMixin],
  props: {
    seriesData: {
      type: Array,
      default () {
        return []
      }
    },
    width: {
      type: String,
      default () {
        return '150px'
      }
    }
  },
  data () {
    return {
      option: {
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 1,
                borderColor: '#464646'
              }
            },
            axisLine: {
              lineStyle: {
                width: 30
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: 50
            },
            data: [
              {
                value: 0,
                name: 'Loading...',
                title: {
                  offsetCenter: ['0%', '-10px']
                },
                detail: {
                  valueAnimation: true,
                  offsetCenter: ['0%', '10px']
                }
              }
            ],
            title: {
              fontSize: 12
            },
            detail: {
              width: 'auto',
              height: 12,
              fontSize: 12,
              color: 'inherit',
              borderColor: 'inherit',
              borderRadius: 18,
              borderWidth: 0.5,
              formatter: '{value}%'
            },
            radius: '90%'
          }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const chartDom = this.$refs.container
      this.chart = echarts.init(chartDom)
      this.option.series[0].data = this.seriesData
      this.chart.setOption(this.option)
    })
  },
  updated () {
    this.option.series[0].data = this.seriesData
    this.chart.setOption(this.option)
  }
}
</script>
